<template>
  <div class="layer" @click="closeStrategyModal">
    <div class="strategy-modal">
      <div class="strategy-modal-box">
        <div class="strategy-modal-body">
          <img src="https://mat1.gtimg.com/news/qiandao/fulizhongxin/yanhua1224/sucai/yanhua-gonglue.png" alt="" />
        </div>
      </div>
      <div class="strategy-modal-close"></div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'StrategyModal',
  emits: ['close'],
  setup(_, { emit }) {
    const closeStrategyModal = () => {
      emit('close')
    }

    return {
      closeStrategyModal
    }
  }
})
</script>

<style lang="scss">
.strategy-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  margin-top: -30px;
  border-radius: 6px;
  background-color: transparent;

  &-close {
    position: absolute;
    bottom: -50px;
    left: 50%;
    transform: translateX(-50%);
    width: 30px;
    height: 30px;
    z-index: 2;
    background: url('../assets/icon-close-bottom.png') no-repeat center;
    background-size: 100%;
  }

  &-box {
    height: 428px;
    overflow: auto;
    border-radius: 6px;
  }

  &-body {
    img {
      border-radius: 6px;
    }
  }
}
</style>
